<template>
  <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'酒店图片管理'"></HeaderNav>
  <div id="storepicpage">
      <!-- 顶部操作区 -->
      <div class="con_top">
          <div class="top-left">
              <h2 class="page-title">酒店图片管理</h2>
              <span class="page-desc">共 <em>{{ picTotal }}</em> 张图片</span>
          </div>
          <button @click="addshow" v-if="myContrArr.includes(11)" class="btn-add">
              <span class="btn-icon">+</span> 新增图片
          </button>
      </div>
      
      <div class="con_type_btn" v-if="serchBtnOpts.length > 0">
           <div class="typebtn">
                <a href="javascript:void(0)" :class="{'is_active': serchImgType==''}" @click="serchPic('')">
                    <span class="tab-count">{{ this.picTotal }}</span>
                    <span class="tab-label">全部</span>
                </a>
                <a href="javascript:void(0)" v-for="item in serchBtnOpts" :key="item.picTypeId" @click="serchPic(item.picTypeId)" :class="{'is_active': serchImgType==item.picTypeId}">
                    <span class="tab-count">{{ item.picTypeCount }}</span>
                    <span class="tab-label">{{ item.picTypeName }}</span>
                </a>
           </div>
      </div>

      <!-- 列表区域 -->
      <div class="tablelist">
          <div class="content">
              <div class="img_content">
                   <div class="img_item" v-for="(item, index) in currentList" :key="index">
                       <div class="imgbox">
                            <img :src="item.storePicSrc" @click="showimg(item.storePicSrc)">
                            <div class="img-hover-mask" @click="showimg(item.storePicSrc)">
                                <div class="mask-content">
                                    <span class="mask-icon">&#128269;</span>
                                    <span>点击预览</span>
                                </div>
                            </div>
                            <div class="img-type-badge" :class="'badge-type-' + item.storePicType">
                                {{ getImgTypeName(item.storePicType) }}
                            </div>
                       </div>
                       <div class="img_action">
                           <a href="javascript:void(0)" v-if="myContrArr.includes(12)" class="btn-del" @click="deleteItem(item.storePicId)">
                               <span class="del-icon">&#128465;</span> 删除
                           </a>
                       </div>
                   </div>
              </div>
              <div class="no_date" v-if="currentList.length == 0">
                   <div class="empty-icon">&#128247;</div>
                   <div class="empty-text">暂无图片数据</div>
                   <div class="empty-hint">点击上方"新增图片"按钮上传酒店图片</div>
              </div>
          </div>
      </div>
  </div>

  <!-- 新增图片弹窗 -->
  <div id="modal-overlay" v-if="is_show" @click.self="closepage(0)">
      <div class="modal-content">
          <div class="modal-header">
              <h3>新增图片</h3>
              <a href="javascript:void(0);" @click="closepage(0)" class="close-btn">&times;</a>
          </div>
          <div class="modal-body">
              <div class="form-item">
                  <label class="form-label"><span class="required-star">*</span>图片类型</label>
                  <div class="form-input-box">
                      <Selectself 
                          v-model="currentForm.imgType" 
                          placeholder="请选择类型" 
                          :optionList="imgTypeOptions"
                      ></Selectself>
                  </div>
              </div>
              <div class="form-item vertical">
                  <label class="form-label"><span class="required-star">*</span>上传图片</label>
                  <div class="form-input-box full-width license-container">
                      <div class="license-item">
                          <div class="imgshowbox" v-for="(item, index) in currentForm.storeImg" :key="index">
                              <a href="javascript:void(0)" @click="clearCurrentImg(index)">&times;</a>
                              <img :src="item" @click="showimg(item)">
                          </div>
                          <div class="picbox">
                              <PicInput 
                                  v-if="!productImg" 
                                  v-model="productImg" 
                                  :inputid="'mgr-pic'" 
                                  :key="comkey"
                              />
                          </div>
                      </div>
                      <div class="upload-tip">支持 jpg、png 格式，建议尺寸 800×600 以上</div>
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <button @click="closepage(0)">取消</button>
              <button class="submit-btn" @click="handleSubmit">保存</button>
          </div>
      </div>
  </div>

  <!-- 图片全屏预览 -->
  <div id="showimgbox" v-if="showimg_src" @click.self="closeshowimgbox">
      <a href="javascript:void(0);" @click="closeshowimgbox">关闭</a>
      <img 
          :src="showimg_src" 
          @load="loadimgfun" 
          ref="imageElement"
          :style="{
              width: show_img_width + 'px',
              height: show_img_height + 'px',
              marginTop: (0 - (show_img_height / 2)) + 'px',
              marginLeft: (0 - (show_img_width / 2)) + 'px'
          }"
      >
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus';
import HeaderNav from '../common/HeaderNav.vue';
import Selectself from '../common/Selectself.vue';
import PicInput from '../common/PicInput.vue'; 
// 请根据实际 Api.js 调整引入

import { selectStorePicType,selectStorePicList ,addStorePic,deleteStorePic,findMenuContrByMenuId} from "@/tools/Api"; 

export default {
  name: "StorePicManager",
  components: {
      HeaderNav,
      Selectself,
      PicInput 
  },
  data() {
      return {
          myMenuCode: 2, 
          myContrArr: [],
          storeDataLoad: false, 
          currentList:[],
          is_show: false,
          storeIdkey:0,
          serchBtnOpts:[],
          picTotal: 0,
          // 图片类型选项
          imgTypeOptions: [
              { id: 1, name: '主图' },
              { id: 2, name: '外观' },
              { id: 3, name: '大厅' },
              { id: 4, name: '客房' },
              { id: 5, name: '公共区域' }
          ],

          // 搜索表单
          serchImgType: '',
          

        
          currentForm: {
              imgType: '',
              storeImg: []
          },
          
          // 图片上传状态
          productImg: "", 
          comkey: 0,      
          
          // 预览状态
          showimg_src: "",
          show_img_width: 0,
          show_img_height: 0
      };
  },
  mounted() {
      this.btnListfind();
    this.getPicTypeList();
    this.fetchPicList();
  },
  watch: {
      productImg(newVal, oldVal) {
          this.inputimgarrfun();
      }
  },
  methods: {
      btnListfind() {
          findMenuContrByMenuId(this.myMenuCode).then(res => {
              if (res.status == 0) {
                  this.myContrArr = res.data;
              }
          }).catch(() => {
              ElMessage({ message: "获取权限失败", type: 'error' });
          });
      },
      serchPic(type){
        this.serchImgType = type;
        this.fetchPicList();
      },

      fetchPicList() {
          selectStorePicList(this.serchImgType).then(res => {
              if (res.status == 0) {
                  // 关联酒店名称
                  this.currentList = res.data;
              }
          }).catch(err => {
              console.error("获取图片列表失败", err);
              ElMessage({ message: "获取图片列表失败", type: 'error' });
          });
      },
      getPicTypeList() {
          selectStorePicType().then(res => {
              if (res.status == 0) {
                  this.serchBtnOpts = res.data;
                  this.picTotal=0
                  for (let i = 0; i < this.serchBtnOpts.length; i++) {
                      this.picTotal += this.serchBtnOpts[i].picTypeCount;
                  }
              }
          }).catch(err => {
              console.error("获取图片类型列表失败", err);
              ElMessage({ message: "获取图片类型列表失败", type: 'error' });
          });
      },
      getImgTypeName(type) {
          const typeObj = this.imgTypeOptions.find(opt => opt.id == type);
          return typeObj ? typeObj.name : '未知类型';
      },


      addshow() {
          this.currentForm = { storeAcctId: '', imgType: '', storeImg: [] };
          this.resetUploadState();
          this.is_show = true;
      },

      resetUploadState() {
          this.productImg = "";
          this.comkey = 0;
          this.showimg_src = "";
          this.show_img_width = 0;
          this.show_img_height = 0;
      },

      inputimgarrfun() {
          if (this.productImg == '') {
              return;
          }
          // 假设上传组件返回的对象中包含 fileFullPath 或直接是 URL
          this.currentForm.storeImg.push(this.productImg.fileFullPath); 
          this.productImg = '';
          this.comkey += 1;
      },

      clearCurrentImg(index) {
          this.currentForm.storeImg.splice(index,1);
      },

      showimg(src) {
          this.showimg_src = src;
      },

      closeshowimgbox() {
          this.showimg_src = "";
          this.show_img_width = 0;
          this.show_img_height = 0;
      },

      async loadimgfun() {
          let w = 0;
          let h = 0;
          const img = new Image();
          img.src = this.showimg_src;
          
          const calcSize = (width, height) => {
              if (width > height) { 
                  this.show_img_width = 600;
                  this.show_img_height = Math.round(600 / width * height);
              } else {
                  this.show_img_height = 600;
                  this.show_img_width = Math.round(600 / height * width);
              }
          };

          await new Promise((resolve) => {
              img.onload = () => {
                  calcSize(img.width, img.height);
                  resolve();
              };
              if (img.complete) {
                   calcSize(img.width, img.height);
                   resolve();
              }
          });
      },

      handleSubmit() {
         
          if (!this.currentForm.imgType) {
              ElMessage({ message: "请选择图片类型", type: 'warning' });
              return;
          }
          if (!this.currentForm.storeImg) {
              ElMessage({ message: "请上传图片", type: 'warning' });
              return;
          }
          
          const params = {
              storePicType: this.currentForm.imgType,
              storePicSrc: this.currentForm.storeImg
          };

          // 假设 API 为 addStoreImage
          addStorePic(params).then(res => {
              if (res.status == 0) {
                  ElMessage({ message: "保存成功", type: 'success' });
                  this.closepage(1);
              } else {
                  ElMessage({ message: res.msg || "保存失败", type: 'error' });
              }
          }).catch(err => {
              ElMessage({ message: "请求失败", type: 'error' });
          });
      },

      deleteItem(id) {
          ElMessageBox.confirm('确定要删除该图片吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              // 假设 API 为 deleteStoreImage，需要传入图片ID或相关标识
               
              
              deleteStorePic(id).then(res => {
                  if (res.status == 0) {
                      ElMessage({ message: "删除成功", type: 'success' });
                      // 重新获取列表
                     this.fetchPicList();
                     this.getPicTypeList();
                  } else {
                      ElMessage({ message: res.msg || "删除失败", type: 'error' });
                  }
              }).catch(err => {
                  ElMessage({ message: "请求失败", type: 'error' });
              });
          }).catch(() => {});
      },

      closepage(isrush) {
          if (isrush == 1) {
              this.fetchPicList();
              this.getPicTypeList();
          }
          this.is_show = false;
          this.currentForm = { storeAcctId: '', imgType: '', storeImg: [] };
          this.resetUploadState();
      },

      previewImage(src) {
          this.showimg(src); 
      }
  }
};
</script>

<style scoped>
/* ===== 基础页面布局 ===== */
#storepicpage {
  width: 100%;
  height: calc(100% - 40px);
  float: left;
  padding: 24px 40px;
  overflow-y: auto;
  box-sizing: border-box;
  background-color: #f5f6f8;
}

/* ===== 顶部操作区 ===== */
#storepicpage .con_top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.top-left {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: 0.5px;
}
.page-desc {
  font-size: 13px;
  color: #999;
}
.page-desc em {
  font-style: normal;
  color: #12ab04d4;
  font-weight: 600;
}
.btn-add {
  height: 40px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #12ab04d4, #0d8a03);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(18,171,4,0.25);
}
.btn-add:hover {
  background: linear-gradient(135deg, #17cf07d4, #12ab04d4);
  box-shadow: 0 6px 16px rgba(18,171,4,0.35);
  transform: translateY(-1px);
}
.btn-icon {
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

/* ===== 图片类型筛选 ===== */
#storepicpage .con_type_btn {
  width: 100%;
  background-color: #fff;
  border-radius: 10px;
  padding: 12px 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}
#storepicpage .con_type_btn .typebtn {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
#storepicpage .con_type_btn .typebtn a {
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #606266;
  background-color: #f8f9fa;
  border: 1px solid #ebeef5;
  transition: all 0.25s;
  cursor: pointer;
}
#storepicpage .con_type_btn .typebtn a .tab-count {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
#storepicpage .con_type_btn .typebtn a .tab-label {
  color: #888;
  font-size: 12px;
}
#storepicpage .con_type_btn .typebtn a:hover {
  color: #12ab04d4;
  background-color: #f0f9eb;
  border-color: #b3e19d;
}
#storepicpage .con_type_btn .typebtn a:hover .tab-count,
#storepicpage .con_type_btn .typebtn a:hover .tab-label {
  color: #12ab04d4;
}
#storepicpage .con_type_btn .typebtn a.is_active {
  color: #fff;
  background: linear-gradient(135deg, #12ab04d4, #0d8a03);
  border-color: #12ab04d4;
  box-shadow: 0 3px 10px rgba(18,171,4,0.2);
}
#storepicpage .con_type_btn .typebtn a.is_active .tab-count,
#storepicpage .con_type_btn .typebtn a.is_active .tab-label {
  color: #fff;
}

/* ===== 图片列表 ===== */
#storepicpage .tablelist {
  width: 100%;
  float: left;
}
#storepicpage .tablelist .content {
  width: 100%;
  float: left;
}
#storepicpage .tablelist .content .img_content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
#storepicpage .tablelist .content .img_content .img_item {
  width: calc(25% - 12px);
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: all 0.3s;
}
#storepicpage .tablelist .content .img_content .img_item:hover {
  box-shadow: 0 8px 28px rgba(0,0,0,0.12);
  transform: translateY(-4px);
}

/* 图片容器 */
#storepicpage .tablelist .content .img_content .img_item .imgbox {
  width: 100%;
  height: 210px;
  overflow: hidden;
  position: relative;
  background: #f0f0f0;
}
#storepicpage .tablelist .content .img_content .img_item .imgbox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}
#storepicpage .tablelist .content .img_content .img_item:hover .imgbox img {
  transform: scale(1.08);
}

/* 图片悬浮遮罩 */
.img-hover-mask {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.5) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 20px;
  opacity: 0;
  transition: opacity 0.35s;
  cursor: pointer;
}
.mask-content {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 18px;
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.3);
}
.mask-icon {
  font-size: 14px;
}
#storepicpage .tablelist .content .img_content .img_item:hover .img-hover-mask {
  opacity: 1;
}

/* 图片类型角标 */
.img-type-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  border-radius: 4px;
  background: linear-gradient(135deg, #12ab04d4, #0d8a03);
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  letter-spacing: 0.5px;
}
.badge-type-1 { background: linear-gradient(135deg, #e57834, #d06520); }
.badge-type-2 { background: linear-gradient(135deg, #3a86ff, #2563eb); }
.badge-type-3 { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }
.badge-type-4 { background: linear-gradient(135deg, #12ab04d4, #0d8a03); }
.badge-type-5 { background: linear-gradient(135deg, #06b6d4, #0891b2); }

/* 操作按钮区 */
.img_action {
  padding: 10px 14px 14px;
  display: flex;
  justify-content: flex-end;
}
.img_action .btn-del {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  padding: 0 14px;
  text-align: center;
  color: #fff;
  border-radius: 6px;
  transition: all 0.2s;
  font-weight: 500;
  background: linear-gradient(135deg, #d81d1d, #e55050);
}
.img_action .btn-del:hover {
  box-shadow: 0 3px 10px rgba(216,29,29,0.3);
  transform: translateY(-1px);
}
.del-icon {
  font-size: 13px;
}

/* ===== 暂无数据 ===== */
.no_date {
  width: 100%;
  text-align: center;
  padding: 80px 0;
}
.empty-icon {
  font-size: 56px;
  margin-bottom: 16px;
  opacity: 0.3;
}
.empty-text {
  font-size: 16px;
  color: #999;
  font-weight: 500;
  margin-bottom: 8px;
}
.empty-hint {
  font-size: 13px;
  color: #ccc;
}

/* ===== 全屏预览 ===== */
#showimgbox {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.8);
  backdrop-filter: blur(4px);
}
#showimgbox img {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 8px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.4);
}
#showimgbox a {
  width: auto;
  height: 40px;
  position: absolute;
  top: 16px;
  right: 16px;
  display: block;
  color: #fff;
  text-align: center;
  line-height: 40px;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(8px);
  padding: 0 20px;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.2);
  transition: all 0.3s;
}
#showimgbox a:hover {
  background: rgba(255,255,255,0.2);
}

/* ===== 模态框 ===== */
#modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}
#modal-overlay .modal-content {
  width: 520px;
  background-color: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  animation: modalIn 0.25s ease;
}
@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
#modal-overlay .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
}
#modal-overlay .modal-header h3 {
  margin: 0;
  font-size: 17px;
  color: #1a1a2e;
  font-weight: 600;
}
#modal-overlay .modal-header .close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  text-decoration: none;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
}
#modal-overlay .modal-header .close-btn:hover {
  background: #f5f5f5;
  color: #333;
}
#modal-overlay .modal-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}
.required-star {
  color: #e57834;
  margin-right: 2px;
}
#modal-overlay .form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 22px;
}
#modal-overlay .form-item:last-child {
  margin-bottom: 0;
}
#modal-overlay .form-item.vertical {
  flex-direction: column;
}
#modal-overlay .form-item .form-label {
  width: 80px;
  flex-shrink: 0;
  font-size: 14px;
  color: #555;
  font-weight: 500;
  line-height: 42px;
  text-align: right;
  padding-right: 12px;
}
#modal-overlay .form-item.vertical .form-label {
  width: 100%;
  text-align: left;
  padding-right: 0;
  line-height: 1.4;
  margin-bottom: 10px;
}
#modal-overlay .form-item .form-input-box {
  flex: 1;
}
#modal-overlay .form-item.vertical .form-input-box {
  width: 100%;
}
.upload-tip {
  font-size: 12px;
  color: #bbb;
  margin-top: 10px;
  padding-left: 2px;
}

/* 图片上传预览 */
.license-container {
  width: 100%;
}
.license-item {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.imgshowbox {
  width: 110px;
  height: 110px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid #eaeaea;
  transition: all 0.3s;
}
.imgshowbox:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}
.imgshowbox a {
  width: 22px;
  height: 22px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 15px;
  color: #fff;
  text-decoration: none;
  border-radius: 50%;
  background: rgba(229,57,53,0.9);
  right: 4px;
  top: 4px;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1;
}
.imgshowbox a:hover {
  background: rgba(229,57,53,1);
  transform: scale(1.1);
}
.imgshowbox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.picbox {
  width: 110px;
  height: 110px;
  border: 2px dashed #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.2s;
}
.picbox:hover {
  border-color: #12ab04d4;
}

/* 模态框底部 */
#modal-overlay .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
}
#modal-overlay .modal-footer button {
  height: 38px;
  padding: 0 22px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  transition: all 0.3s;
}
#modal-overlay .modal-footer button:first-child {
  background-color: #fff;
  color: #666;
  border: 1px solid #dcdfe6;
}
#modal-overlay .modal-footer button:first-child:hover {
  color: #333;
  border-color: #c0c4cc;
  background: #f5f5f5;
}
#modal-overlay .submit-btn {
  background: linear-gradient(135deg, #12ab04d4, #0d8a03) !important;
  box-shadow: 0 4px 12px rgba(18,171,4,0.25);
}
#modal-overlay .submit-btn:hover {
  box-shadow: 0 6px 16px rgba(18,171,4,0.35);
  transform: translateY(-1px);
}
</style>